// HCP-112928: Identity returns 429 when the daily code limit per phone/e-mail or the per-IP limit is reached.
export const TOO_MANY_REQUESTS = 429

export const isTooManyRequests = (errorCode?: number): boolean => errorCode === TOO_MANY_REQUESTS
